import React, { useState, useEffect } from 'react';
import { Formik } from 'formik';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import FormWrapper from '~FormWrapper';
import GasBottlesForm from './GasBottlesForm';

import {
  getUserOrdererOrganizationPhone,
  getUserOrdererOrganizationId,
} from '~features/user/ducks';

import { getBottles, getTimeInfo } from '../../services/api.helpers';
import { useOnSubmit } from '~hooks/useOnSubmit';
import { useOnEdit } from '~hooks/useOnEdit';
import { removeEmptyKeys, isPhoneNumberValid } from '../validations';

const validate = values => {
  const errors = {};

  if (values.gasbottles.length < 1) {
    errors.gasbottles = 'Vaadittu';
  }

  if (values.gasbottles.length > 0) {
    const gasbottlesErrors = {};
    values.gasbottles.forEach((gasbottles, index) => {
      if (!gasbottles.id) {
        gasbottlesErrors[index] = 'Vaadittu';
      }
      if (!gasbottles.itemCount) {
        gasbottlesErrors[index] = 'Vaadittu';
      }
    });
    if (Object.keys(gasbottlesErrors).length > 0) {
      errors.gasbottles = gasbottlesErrors;
    }
  }

  if (!values.deliveryAddress) {
    errors.deliveryAddress = 'Vaadittu';
  }

  errors.contactPhone = isPhoneNumberValid(values.contactPhone);

  return removeEmptyKeys(errors);
};

const GasBottles = props => {
  const { formId, edit } = props;
  const { orderId } = useParams();
  const [timeInfo, setTimeInfo] = useState();
  const [bottles, setBottles] = useState();
  const organizations = useSelector(state => state.reducer.organizations);
  const userPhone = useSelector(state =>
    getUserOrdererOrganizationPhone(state)
  );
  const userOrganizationId = useSelector(state =>
    getUserOrdererOrganizationId(state)
  );

  const userOrganization = organizations?.find(
    o => o.id === userOrganizationId
  );

  useEffect(() => {
    const update = async () => {
      const tempTimeInfo = await getTimeInfo(formId);
      const bottles = await getBottles();
      if (bottles) {
        setBottles(
          bottles.map(bottle => ({
            value: bottle.id,
            label: bottle.description,
            requireComment: bottle.requireComment, // For Muu
            comment: '', // For Muu
          }))
        );
      } else {
        console.error('Fetching gas bottles failed!');
      }

      setTimeInfo(tempTimeInfo);
    };
    update();
  }, [formId]);

  const onFormSubmit = useOnSubmit();
  const onFormEdit = useOnEdit();

  return (
    <Formik
      initialValues={{
        gasbottles: [{ id: null, itemCount: '1' }],
        deliveryAddress: null,
        isUrgent: false,
        additionalInfo: '',
        collectFeedback: true,
        contactPhone: userPhone,
        infectionRisk: false,
      }}
      validate={validate}
      onSubmit={async (values, { setSubmitting }) => {
        setSubmitting(true);
        const method = edit ? onFormEdit : onFormSubmit;
        await method({
          fields: {
            ...values,
            gasbottles: values.gasbottles?.length
              ? values.gasbottles.map(p => ({
                  id: p.id.value,
                  itemCount: p.itemCount,
                  title: p.id.label,
                  comment: p.id.comment,
                }))
              : null,
          },
          setSubmitting,
          orderId,
          formId,
        });
      }}
    >
      {formikProps => (
        <FormWrapper
          {...props}
          title="Tilaa tavarakuljetus"
          organizations={organizations}
          userOrganization={userOrganization}
          bottles={bottles}
          timeInfo={timeInfo}
          formik={formikProps}
          Component={GasBottlesForm}
        />
      )}
    </Formik>
  );
};

export default GasBottles;
